module.exports = __webpack_public_path__ + "b6a8eea3ffe3f14981bf45d4ef7b956b.pdf";